import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { priorityColor } from '../../shared/constants';
import type { Option } from '../tasks.types';

/**
 * Priority picker whose options, and the chosen value, carry the priority's colour — the
 * same `PRIORITY_COLORS` table the Assign Work screen and task views read, so a level
 * looks the same everywhere (red High, yellow Medium, green Low, dark red Urgent).
 */
export default function PriorityField({
  priorities,
  value,
  onChange,
  sx,
}: {
  priorities: Option[];
  value: string;
  onChange: (code: string) => void;
  sx?: object;
}) {
  const color = priorityColor(value);
  return (
    <TextField
      select
      label='Priority'
      size='small'
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={{
        ...(color && {
          '& .MuiSelect-select': { color, fontWeight: 600 },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: color },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: color },
          '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: color, borderWidth: 2 },
          '& .MuiInputLabel-root.Mui-focused': { color },
        }),
        ...sx,
      }}
    >
      {priorities.map((p) => (
        <MenuItem key={p.id} value={p.code ?? ''}>
          <Typography component='span' variant='body2' sx={{ color: priorityColor(p.code) ?? p.color ?? 'text.primary', fontWeight: 600 }}>
            {p.label}
          </Typography>
        </MenuItem>
      ))}
    </TextField>
  );
}
